const getters = {
  getInsurerList: (state) => state.insurerList,
};

export default getters;
